import React, { useState } from 'react';
import { Modal, ModalTitle, ModalBody, ModalFooter } from 'design-system/src/components/Modal';
import { Typography } from 'design-system/src/components/Typography/Typography';
import Button from 'design-system/src/components/Button/Button';
import { ResponseInput } from '../../tableItemDetailViewComponents/FormComponents';

export type SubmitWithoutInfoWarningModalProps = {
  updating: boolean;
  onSubmit: (ehrSubmission?: string) => void;
  onClose: () => void;
};

/**
 * A modal that warns the user that they're submitting the task with no info attached.
 */
const SubmitWithoutInfoWarningModal = ({ updating, onSubmit, onClose }: SubmitWithoutInfoWarningModalProps) => {
  const [inputValue, setInputValue] = useState('');

  return (
    <Modal onClose={onClose}>
      <ModalTitle>Submit PA without information</ModalTitle>

      <ModalBody>
        <Typography styledAs="bodyDMSans">
          <strong>Important:</strong> Tandem will submit the PA without the information requested. If you are waiting on
          information from the patient or prescriber, please leave the task open until ready to submit.
        </Typography>
        <div className="mt-2">
          <ResponseInput
            aria-label="Reason for submitting without information"
            placeholder="If information is unavailable, please provide an appropriate answer to the question(s)"
            value={inputValue}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setInputValue(e.target.value)}
            className="box-border !min-h-[70px] w-full"
          />
        </div>
      </ModalBody>

      <ModalFooter>
        <Button size="sm" onClick={onClose} disabled={updating} variant="tertiary">
          Back
        </Button>
        <Button size="sm" onClick={() => onSubmit(inputValue)} isLoading={updating} disabled={!inputValue.trim()}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SubmitWithoutInfoWarningModal;
